<template>
  <div class="main-holder">
    <div class="top-holder">
      <div class="search-holder">
        <form @submit.prevent="handleSearch">
          <input
            type="text"
            v-model="query"
            :placeholder="$t('search_bar.input_placeholder')"
          />
        </form>
        <div class="search-icon-holder" @click="handleSearch">
          <i class="fal fa-search"></i>
        </div>
        <div class="results-for-query">
          <span v-if="response.length > 0">{{ $t("search_bar.result") }}</span>
          <span v-if="response.length === 0">{{
            $t("search_bar.result_not_first")
          }}</span>
          «<b>{{ currentQuery }}</b
          >»‎
          <span v-if="response.length === 0">{{
            $t("search_bar.result_not")
          }}</span>
        </div>
      </div>
      <div class="live-video-wrapper">
        <div style="position: absolute; top: 0; left: 0; width: 100%">
          <LiveStreamWindow />
        </div>
      </div>
    </div>
    <div
      :style="`background-image: url(${background})`"
      class="content-wrapper"
      ref="content"
    >
      <div class="content-inner">
        <div class="collar">
          <template v-if="response.length === 0 && count === 0">
            <div class="not-found">
              <div class="svg">
                <svg
                  width="100%"
                  height="100%"
                  viewBox="0 0 167 69"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M49.7 50.9C48.9 50.7 45.5667 50.5333 39.7 50.4V68.1H28.1V50.4H0.8V48.3L38.1 0.899998H39.7V40.1H40.5C42.3 40.1 43.6333 39.9667 44.5 39.7C45.4333 39.4333 46.0667 39 46.4 38.4C46.7333 37.8 47 36.8667 47.2 35.6H49.3C49.3 42.6667 49.4333 47.7667 49.7 50.9ZM28.1 40.1V16.8L10 40.1H28.1ZM85.632 0.899998C90.8987 0.899998 95.5987 2 99.732 4.2C103.865 6.4 107.065 9.5 109.332 13.5C111.665 17.5 112.832 22.1 112.832 27.3C112.832 32.6333 111.632 37.4333 109.232 41.7C106.899 45.9667 103.565 49.3333 99.232 51.8C94.9654 54.2 90.0654 55.4 84.532 55.4C79.332 55.4 74.6654 54.3 70.532 52.1C66.3987 49.9 63.1654 46.8 60.832 42.8C58.4987 38.8 57.332 34.1667 57.332 28.9C57.332 23.6333 58.4987 18.8667 60.832 14.6C63.232 10.3333 66.5654 7 70.832 4.6C75.0987 2.13333 80.032 0.899998 85.632 0.899998ZM84.732 2.7C82.332 2.7 80.1987 3.73333 78.332 5.8C76.4654 7.86666 74.9987 10.8667 73.932 14.8C72.932 18.6667 72.432 23.2667 72.432 28.6C72.432 37.0667 73.632 43.3667 76.032 47.5C78.4987 51.5667 81.632 53.6 85.432 53.6C87.832 53.6 89.932 52.5667 91.732 50.5C93.5987 48.3667 95.0654 45.3667 96.132 41.5C97.1987 37.5667 97.732 32.9333 97.732 27.6C97.732 19.1333 96.4987 12.8667 94.032 8.8C91.632 4.73333 88.532 2.7 84.732 2.7ZM166.204 50.9C165.404 50.7 162.071 50.5333 156.204 50.4V68.1H144.604V50.4H117.304V48.3L154.604 0.899998H156.204V40.1H157.004C158.804 40.1 160.137 39.9667 161.004 39.7C161.937 39.4333 162.571 39 162.904 38.4C163.237 37.8 163.504 36.8667 163.704 35.6H165.804C165.804 42.6667 165.937 47.7667 166.204 50.9ZM144.604 40.1V16.8L126.504 40.1H144.604Z"
                  />
                </svg>
              </div>
              <div class="not-found-text">{{ $t("error.nothing-found") }}</div>
            </div>
          </template>
          <!-- <div class="collar-meta" style="display:flex; align-items:center; margin-top:15px; font-weight:900;">
            <div class="filter_arrow" v-if="filter_new" @click="filter_new = false">
              <i class="fas fa-arrow-alt-circle-up"></i>
              <i class="far fa-arrow-alt-circle-down"></i>
            </div>
            <div class="filter_arrow" v-else @click="filter_new = true">
              <i class="far fa-arrow-alt-circle-up"></i>
              <i class="fas fa-arrow-alt-circle-down"></i>
            </div>
            <span v-if="filter_new">{{$t('search_bar.sort_new')}}</span>
            <span v-else>{{$t('search_bar.sort_old')}}</span>
          </div> -->
        </div>

        <div class="content-holder">
          <template v-if="response.length > 0">
            <div
              class="card-wrapper"
              v-for="(item, index) in response"
              :class="index % 2 === 0 ? '' : 'additional'"
              :key="item.id"
            >
              <router-link
                :to="
                  $i18nRoute({
                    name: 'NewsDetail',
                    params: { slug: item.url, category: 'feed' },
                  })
                "
                class="card-inner"
              >
                <div class="img-container">
                  <ImageContainer
                    :src="item.image.medium"
                    :thumb="item.image.thumbnail"
                    :alt="item.title"
                  />
                  <div class="cat-holder">{{ item.sub_category.name }}</div>
                </div>
                <div class="meta-holder">
                  <div class="title limited-text" style="--snup: 4">
                    {{ item.title }}
                  </div>
                  <div class="date-wrapper">
                    <span class="date">{{ handleDate(item.pub_date) }},</span>
                    <span class="date" style="padding-left: 0.44em">{{
                      handleTime(item.pub_date)
                    }}</span>
                  </div>
                </div>
              </router-link>
            </div>
          </template>
        </div>
        <div class="content-holder" v-if="show.spinner && count !== 0">
          <div
            class="card-wrapper pointer-none"
            v-for="(item, index) in 10"
            :class="index % 2 === 0 ? '' : 'additional'"
            :key="item"
          >
            <div class="card-inner">
              <div class="img-container">
                <div class="kground" />
                <div class="cat-holder"></div>
              </div>
              <div class="meta-holder">
                <div class="title limited-text" style="--snup: 4">
                  <span class="kground">
                    Instead Instead Instead much peace according appearmajor
                    push. Instead much peace according meet appearmajor push.
                    Instead much peace
                  </span>
                </div>
                <div class="date-wrapper">
                  <span class="date kground">31.05.2021.12.12 , 00:00</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LiveStreamWindow from "../components/LiveStreamWindow";
import ImageContainer from "../components/ImageContainer";
import { watch, ref, computed, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useLanguage } from "../utils/language";
import { useInfiniteScroll } from "../utils/infiniteScroll";
import { useStore } from "vuex";
import { useFormatter } from "../utils/formatter";

export default {
  components: {
    LiveStreamWindow,
    ImageContainer,
  },
  setup(props) {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const query = ref(props.query);
    const currentQuery = ref(props.query);
    const content = ref(null);
    const show = reactive({
      spinner: true,
    });

    const pageSize = 10;

    const scrollEnd = () => {
      show.spinner = false;
    };

    const { i18n } = useLanguage();

    const handleSearch = () => {
      if (query.value !== undefined && query.value?.trim().length > 0) {
        router.push({
          name: `${i18n.global.locale.value || i18n.global.locale}_SearchQuery`,
          params: {
            query: query.value.trim(),
            category: "feed",
          },
        });
      } else {
        router.push({
          name: `${i18n.global.locale.value || i18n.global.locale}_Search`,
          params: {
            category: "feed",
          },
        });
      }
    };

    const refreshData = () => {
      store.commit("flushSearchState");
      const { startInfiniteScroll, loadData } = useInfiniteScroll({
        wrapper: content,
        retrieve: (load, cb) => {
          store.dispatch("searchNews", { query: currentQuery.value, cb });
        },
        newsCount: computed(() => store.getters.searchCount),
        currentPage: computed(() => store.getters.searchPage),
        pageSize,
        scrollEnd,
      });
      startInfiniteScroll();
      show.spinner = true;
      loadData();
    };

    watch(
      () => route.params.query,
      (newVal) => {
        currentQuery.value = newVal;
        query.value = newVal;

        refreshData();
      },
      { immediate: true }
    );

    watch(
      () => i18n.global.locale.value,
      () => refreshData()
    );

    return {
      show,
      query,
      content,
      currentQuery,
      background: require("@/assets/words-bg.png"),
      handleSearch,
      response: computed(() => store.getters.searchNews),
      count: computed(() => store.getters.searchCount),
      ...useFormatter(),
    };
  },
};
</script>

<style lang="scss" scoped>
.main-holder {
  --top-offset: calc(160px + 30px);
  margin-top: var(--top-offset);
  width: 100%;

  .top-holder {
    display: flex;
    justify-content: flex-end;
    width: var(--main-wrapper-width);
    margin-left: auto;
    margin-right: auto;

    .search-holder {
      width: 100%;
      max-width: 837px;
      position: relative;

      input {
        width: 100%;
        height: 56px;
        font-family: Open Sans;
        font-size: 1.25em;
        background-color: transparent;
        border-radius: 4px;
        transition: all 0.4s ease;
        color: var(--primary-font-color);
        border: 1px solid rgba(var(--secondary-bg), 0.5);
        padding-left: 30px;
      }

      .search-icon-holder {
        position: absolute;
        right: -30px;
        top: 1px;
        height: 56px;
        width: 56px;
        font-size: 2.4em;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        background-color: var(--background-color);
      }

      .results-for-query {
        font-family: Open Sans;
        font-size: 1.5em;
        line-height: 1.875em;
        padding-top: 1.875rem;
        padding-bottom: 2.5rem;
      }
    }

    .live-video-wrapper {
      width: 368px;
      margin-left: 5.875rem;
      position: relative;
    }
  }

  .collar-recomen {
    // Рекомендации для вас
    margin-top: 3em;
    .content-inner {
      padding-top: 4rem !important;
    }
  }

  .content-wrapper {
    width: 100%;
    height: auto;

    .content-inner {
      width: var(--main-wrapper-width);
      margin-left: auto;
      min-height: 150px;
      margin-right: auto;
      height: auto;
      position: relative;
      // padding-top: 2.5rem;
      padding-top: 3rem;
      padding-bottom: 7.75rem;
      margin-bottom: 5.625rem;

      .collar {
        position: absolute;
        top: 0;
        left: 70px;
        width: 50%;
        min-height: 100%;
        background-color: var(--foreground-color);
        border-radius: 7px;
        display: flex;

        .not-found {
          --nf-color: var(--secondary-font-color);

          color: var(--nf-color);
          width: 100%;
          height: auto;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 30px 16%;

          .svg {
            width: 100%;
            display: flex;

            path {
              fill: var(--nf-color);
            }
          }

          .not-found-text {
            padding-top: 1em;
            font-size: 2em;
          }
        }

        .recomendation-name {
          display: inline-block;
          position: relative;
          padding: 0.3em 1em;
          font-size: 1.5em;
          color: black;
        }
        .collar-meta {
          font-family: Open Sans;
          margin-top: 5px;
          margin-left: 34px;
          font-weight: 300;
          font-size: 1.2em;
          line-height: 1.5em;
          color: rgba(var(--primary-bg), 0.6);
          cursor: pointer;

          i {
            margin-right: 8px;
          }
        }
      }

      .card-wrapper {
        --border-color: var(--foreground-color);
        color: var(--secondary-font-color);
        height: 144px;
        position: relative;
        width: 100%;
        max-width: 720px;

        .card-inner {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          cursor: pointer;
          display: flex;

          .img-container {
            position: relative;
            width: 300px;
            height: 200px;
            border: 10px solid var(--border-color);
            border-radius: 4px;
            background-color: var(--border-color);

            .cat-holder {
              position: absolute;
              top: 0;
              left: 0;
              background-color: var(--border-color);
              font-family: Open Sans;
              font-weight: bold;
              line-height: 1.5em;
              padding-left: 0.375rem;
              padding-right: 0.625rem;
              text-transform: uppercase;
            }

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 4px;
            }
          }

          .meta-holder {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            margin-top: 2.5rem;
            max-width: 320px;

            .title {
              font-family: Alice;
              font-weight: 500;
              font-size: 1.25em;
            }

            .date {
              font-family: Open Sans;
              font-weight: 300;
              line-height: 1.25rem;
              margin-bottom: 10px;
            }
          }
        }

        &.additional {
          --border-color: var(--background-color);
          color: var(--primary-font-color);
          margin-left: clamp(50%, 720px, 100%);
        }
      }
    }
  }
}

.filter_arrow {
  display: flex;
  align-items: center;
  i {
    display: inline-block;
    font-size: 1.8em;
    color: black;
  }
}

@media screen and (max-width: 1536px) {
  .collar {
    width: 55% !important;
    left: 70px !important;
  }
  .card-wrapper {
    height: 114px !important;
    max-width: 560px !important;
    .img-container {
      width: 240px !important;
      height: 160px !important;
    }
    .meta-holder {
      max-width: 290px !important;
      font-size: 1.1em !important;
      margin-top: 1.2em !important;
    }
  }
  .collar-meta {
    margin-top: 10px !important;
    // color: white  !important;
    margin-left: 50px !important;
    font-size: 1.5em !important;
    font-weight: 900 !important;
    white-space: nowrap;
  }
  .filter_arrow {
    margin-right: 5px;
    i {
      // color: white !important;
      font-size: 1.9em !important;
    }
  }
}

@media screen and (max-width: 1366px) {
  .main-holder {
    zoom: 0.8;
  }
}

@media screen and (max-width: 1100px) {
  .collar {
    left: 120px !important;
  }
  .additional {
    margin-left: 55% !important;
  }
  .card-wrapper {
    height: 104px !important;
    max-width: 500px !important;
    .img-container {
      width: 210px !important;
      height: 130px !important;
    }
    .meta-holder {
      max-width: 260px !important;
    }
  }
}
@media screen and (max-width: 900px) {
  .collar {
    width: 50% !important;
    left: 60px !important;
  }
  .additional {
    margin-left: 52% !important;
  }
  .card-wrapper {
    height: 94px !important;
    max-width: 450px !important;
    .img-container {
      width: 200px !important;
    }
    .meta-holder {
      max-width: 210px !important;
    }
  }
}

@media screen and (max-width: 765px) {
  .content-inner {
    margin-bottom: 1.625rem !important;
    padding-bottom: 1.75rem !important;
    .collar {
      left: 15% !important;
      min-width: 290px !important;
    }
  }
  .live-video-wrapper {
    display: none;
  }
  .main-holder {
    margin-top: 6em !important;
    .top-holder {
      justify-content: center;
      .search-holder {
        position: relative;
        form {
          border: none;
          max-width: 70%;
          margin-left: auto;
          margin-right: auto;
          input {
            border: none;
            border-bottom: 3px solid rgba(255, 255, 255, 0.7);
            padding-left: 0px;
            height: 45px;
          }
        }
        .search-icon-holder {
          right: 15%;
          position: absolute;
          top: 0;
          background: inherit;
          font-size: 1.75em;
          height: 45px;
        }
        .results-for-query {
          font-size: 1.25em;
          padding-top: 1.275rem;
          padding-bottom: 1.4rem;
        }
      }
    }
  }
  .additional {
    margin-left: auto !important;
  }
  .card-wrapper {
    height: 175px !important;
    max-width: 400px !important;
    .img-container {
      width: 200px !important;
      border: 6px solid var(--border-color) !important;
      height: 140px !important;
    }
    .meta-holder {
      max-width: 190px !important;
    }
  }
}
@media screen and (max-width: 560px) {
  .collar {
    background-color: inherit !important;
    position: static !important;
    width: 100% !important;
    display: flex;
    justify-content: center;

    .not-found {
      --nf-color: var(--primary-font-color) !important;
    }
  }
  .card-wrapper {
    color: var(--primary-font-color) !important;
    .img-container {
      border: 5px solid black !important;
      background-color: black !important;
      .cat-holder {
        background-color: black !important;
        color: white;
      }
    }
    .meta-holder {
      padding-left: 10px !important;
    }
  }
  .collar-meta {
    margin-top: 0px !important;
    color: white !important;
    margin-left: 0px !important;
    font-size: 1.4em !important;
    font-weight: 900 !important;
    white-space: nowrap;
  }
  .filter_arrow {
    margin-right: 5px;
    i {
      color: white !important;
      font-size: 1.9em !important;
    }
  }
  .results-for-query {
    padding-bottom: 0px !important;
  }

  .collar-recomen {
    margin-top: 0em !important;
  }
  .recomendation-name {
    color: white !important;
    padding: 0em 0em 1em 0em !important;
  }
}
@media screen and (max-width: 455px) {
  .search-holder {
    form {
      max-width: 90%;
      input {
        font-size: 1.25em;
        border-bottom: 2px solid rgba(255, 255, 255, 0.7);
        height: 40px;
      }
    }
    .search-icon-holder {
      height: 40px;
      right: 5%;
      font-size: 1.5em;
    }
    .results-for-query {
      font-size: 1.05em;
    }
  }
}
@media screen and (max-width: 400px) {
  .content-inner {
    margin-bottom: 1.625rem !important;
    padding-bottom: 1.75rem !important;
    .collar {
      left: 15% !important;
      min-width: 290px !important;
    }
  }
  .live-video-wrapper {
    display: none;
  }
  .main-holder {
    margin-top: 6em !important;
    .top-holder {
      justify-content: center;
      .search-holder {
        position: relative;
        form {
          border: none;
          max-width: 70%;
          margin-left: auto;
          margin-right: auto;
          input {
            border: none;
            border-bottom: 3px solid rgba(255, 255, 255, 0.7);
            padding-left: 0px;
            height: 45px;
          }
        }
        .search-icon-holder {
          right: 15%;
          position: absolute;
          top: 0;
          background: inherit;
          font-size: 1.75em;
          height: 45px;
        }
        .results-for-query {
          font-size: 1.25em;
          padding-top: 1.275rem;
          padding-bottom: 1.4rem;
        }
      }
    }
  }
  .additional {
    margin-left: 0 !important;
  }
  .card-wrapper {
    height: 165px !important;
    max-width: auto !important;
    .img-container {
      width: 190px !important;
      border: 0px solid var(--border-color) !important;
      height: 120px !important;
    }
    .meta-holder {
      max-width: 160px !important;
      margin-top: 0px !important;
      .date {
        margin-bottom: 0px !important;
      }
    }
  }
}
</style>
